module.exports = __webpack_public_path__ + "img/電気回路_3_5_4.a61a3dde.png";